import './radioButton.css';

function RadioButton(props) {
  const { text, id, htmlFor } = props;
  return (
    <div className="radioButton">
      <input type="radio" name="custom" id={id} />
      <label htmlFor={htmlFor}> {text || ''} </label>
    </div>
  );
}

export default RadioButton;
